import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/cylinder-volume-calculator',
  component: () => import('../../routes/CylinderVolume.svelte'),
  card: {
    id: 'cylinder-volume-calculator',
    title: 'Cylinder Volume Calculator',
    description: 'Calculate the volume, surface area, and other properties of a cylinder from radius and height.',
    icon: 'radio_button_unchecked',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/cylinder-volume-calculator',
    category: 'Conversion & Math',
  },
  seo: {
    title: 'Cylinder Volume Calculator – Find Cylinder Volume & Surface Area',
    description: 'Free cylinder volume calculator. Enter radius and height to calculate volume, surface area, lateral surface area, base area, and circumference of a cylinder. Works in inches, feet, cm, meters and more.',
  },
};

export default meta;
